import { render, staticRenderFns } from "./card-client-clean-dash.vue?vue&type=template&id=3f50e2a6&"
import script from "./card-client-clean-dash.vue?vue&type=script&lang=js&"
export * from "./card-client-clean-dash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports